import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";

const FetchComponentList = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const accessToken = queryParams.get("userAuthToken");

  const [VMSRSSystemCode, setVMRSSystemCode] = useState('');
  const [VMRSAssemblyCode, setVMRSAssemblyCode] = useState('');

  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    setVMRSSystemCode(props.vmrsSystemCode);
    setVMRSAssemblyCode(props.vmrsAssemblyCode);

    if (typeof (props.value) === 'string') {
      setSelectedValue({
        value: props.id,
        label: props.value
      })
    } else {
      setSelectedValue(props.value)
    }

  }, [props, props.value, props.vmrsSystemCode, props.vmrsAssemblyCode])

  const loadOptions = async (searchQuery, _, { page }) => {

    const response = await fetch(
      `/api/v1/service_codes/vmrs/components?vmrs_system_code=${VMSRSSystemCode ? VMSRSSystemCode : ''}&vmrs_assembly_code=${VMRSAssemblyCode ? VMRSAssemblyCode : ''}&search=${searchQuery}&page=${page}`, {
      method: 'GET',
      headers: {
        'Access-Token': accessToken,
      },
    }
    );
    const responseJSON = await response.json();

    let options = responseJSON.vmrs_services.map((option) => ({
      label: `${option.component_description}`,
      value: `${option.code}`,
      data: option,
    }))

    return {
      options: options,
      hasMore: responseJSON.meta.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#5195FB',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
  };

  return (
    <>
      { typeof (props.value) === 'string' ?
        <AsyncPaginate
          key={JSON.stringify(VMSRSSystemCode)}
          defaultValue={{ value: props.value, label: props.value }}
          loadOptions={loadOptions ? loadOptions : null}
          onChange={onChange}
          isSearchable={true}
          placeholder="Components"
          className='service_dropdown'
          styles={customStyles}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        /> :

        <AsyncPaginate
          key={JSON.stringify(VMSRSSystemCode)}
          value={props.value}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Components"
          className='service_dropdown'
          styles={customStyles}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        />
      }
    </>
  );
};

FetchComponentList.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default FetchComponentList;
